module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>percent</title><path d=\"M40.56,32.12A8.44,8.44,0,1,0,49,40.56,8.44,8.44,0,0,0,40.56,32.12Zm0,11.48a3,3,0,1,1,3-3A3,3,0,0,1,40.56,43.6Z\"></path><rect x=\"-5.31\" y=\"21.45\" width=\"60.71\" height=\"7.03\" transform=\"translate(-10.32 25.03) rotate(-45)\"></rect><path d=\"M9.54,1A8.44,8.44,0,1,0,18,9.46,8.44,8.44,0,0,0,9.54,1Zm0,11.48a3,3,0,1,1,3-3A3,3,0,0,1,9.54,12.5Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/percent.svg
// module id = 501
// module chunks = 1